import { Box, Text, Flex, Textarea } from "@chakra-ui/react";
import { colors } from "../../theme";

/**
 * AppTextarea - Reusable textarea component compatible with React Hook Form
 * 
 * @param {string} label - Label text for the textarea
 * @param {string} name - Field name for form registration
 * @param {function} register - React Hook Form register function
 * @param {object} errors - React Hook Form errors object
 * @param {boolean} required - Whether field is required
 * @param {string} placeholder - Placeholder text
 * @param {boolean} disabled - Whether textarea is disabled
 * @param {number} rows - Number of rows
 * @param {object} textareaProps - Additional props for textarea
 */
const AppTextarea = ({
  label,
  name,
  register,
  errors,
  required = false,
  placeholder = "",
  disabled = false,
  rows = 4,
  textareaProps = {},
  ...rest
}) => {
  const hasError = errors && errors[name];

  return (
    <Box w="100%" {...rest}>
      {label && (
        <Flex mb={1.5} alignItems="center">
          <Text
            fontSize="sm"
            fontWeight="500"
            color={colors.text}
          >
            {label}
          </Text>
          {required && (
            <Text color={colors.primary} ml={1}>
              *
            </Text>
          )}
        </Flex>
      )}
      <Textarea
        placeholder={placeholder}
        disabled={disabled}
        rows={rows}
        {...(register ? register(name, { required: required ? `${label || name} is required` : false }) : {})}
        bg="white"
        borderColor={hasError ? colors.primary : colors.disabled}
        borderWidth="1px"
        borderRadius="md"
        px={4}
        py={2}
        fontSize="sm"
        color={colors.text}
        resize="vertical"
        _placeholder={{ color: colors.placeholder }}
        _hover={{
          borderColor: hasError ? colors.primary : colors.textSecondary,
        }}
        _focus={{
          borderColor: colors.primary,
          boxShadow: `0 0 0 1px ${colors.primary}`,
          outline: "none",
        }}
        _disabled={{
          bg: colors.disabled,
          cursor: "not-allowed",
        }}
        {...textareaProps}
      />
      {hasError && (
        <Text color={colors.primary} fontSize="xs" mt={1}>
          {errors[name]?.message || `${label || name} is required`}
        </Text>
      )}
    </Box>
  );
};

export default AppTextarea;
